if (!customElements.get('header-tabs')) {
  customElements.define(
    'header-tabs',
    class extends HTMLElement {
      constructor() {
        super();

        this.grid = this.querySelector('[data-category-grid]');
        this.items = this.grid?.querySelectorAll('[data-category-item]');
        this.header = this.querySelector('[data-category-header]');
        this.buttons = this.header?.querySelectorAll('button[data-category]');
      }

      connectedCallback() {
        if (this.grid && this.items && this.header && this.buttons) {
          this.header.addEventListener('click', (e) => {
            if (e.target instanceof HTMLElement && e.target.closest('[data-category]')) {
              const button = e.target.closest('button[data-category]');
              const category = e.target.closest('[data-category]')?.getAttribute('data-category');

              if (category && button && button instanceof HTMLButtonElement) {
                this.toggleGrid(button);
              }
            }
          });
        }
      }

      /**
       * Toggles the grid based on the category
       * @param {HTMLButtonElement} button - The button that was clicked
       * @returns {void}
       */
      toggleGrid(button) {
        if (button.getAttribute('data-active') === 'true') return;

        const category = button.getAttribute('data-category');

        this.buttons?.forEach((button) => {
          button.setAttribute('data-active', 'false');
        });

        button.setAttribute('data-active', 'true');

        this.items?.forEach((item) => {
          item.setAttribute('data-active', 'false');

          requestAnimationFrame(() => {
            if (category === 'all') {
              item.setAttribute('data-active', 'true');
              return;
            }

            const itemCategory = item.getAttribute('data-category-item');
            item.setAttribute('data-active', itemCategory === category ? 'true' : 'false');
          });
        });
      }
    },
  );
}
